var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgQrBold = function SvgQrBold(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 1H2C1.44772 1 1 1.44772 1 2V6C1 6.55228 1.44772 7 2 7H6C6.55228 7 7 6.55228 7 6V2C7 1.44772 6.55228 1 6 1ZM3 5V3H5V5H3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9H2C1.44772 9 1 9.44772 1 10V14C1 14.5523 1.44772 15 2 15H6C6.55228 15 7 14.5523 7 14V10C7 9.44772 6.55228 9 6 9ZM3 13V11H5V13H3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 1H10C9.44772 1 9 1.44772 9 2V6C9 6.55228 9.44772 7 10 7H14C14.5523 7 15 6.55228 15 6V2C15 1.44772 14.5523 1 14 1ZM11 5V3H13V5H11Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.79999H9.50001C9.11341 8.79999 8.80001 9.11339 8.80001 9.49999V10.5C8.80001 10.8866 9.11341 11.2 9.50001 11.2H10.5C10.8866 11.2 11.2 10.8866 11.2 10.5V9.49999C11.2 9.11339 10.8866 8.79999 10.5 8.79999Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 8.79999H13.5C13.1134 8.79999 12.8 9.11339 12.8 9.49999V10.5C12.8 10.8866 13.1134 11.2 13.5 11.2H14.5C14.8866 11.2 15.2 10.8866 15.2 10.5V9.49999C15.2 9.11339 14.8866 8.79999 14.5 8.79999Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12.8H13.5C13.1134 12.8 12.8 13.1134 12.8 13.5V14.5C12.8 14.8866 13.1134 15.2 13.5 15.2H14.5C14.8866 15.2 15.2 14.8866 15.2 14.5V13.5C15.2 13.1134 14.8866 12.8 14.5 12.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.8H9.50001C9.11341 12.8 8.80001 13.1134 8.80001 13.5V14.5C8.80001 14.8866 9.11341 15.2 9.50001 15.2H10.5C10.8866 15.2 11.2 14.8866 11.2 14.5V13.5C11.2 13.1134 10.8866 12.8 10.5 12.8Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.8H11.5C11.1134 10.8 10.8 11.1134 10.8 11.5V12.5C10.8 12.8866 11.1134 13.2 11.5 13.2H12.5C12.8866 13.2 13.2 12.8866 13.2 12.5V11.5C13.2 11.1134 12.8866 10.8 12.5 10.8Z"
  })));
};
export default SvgQrBold;